module.exports = __webpack_public_path__ + "static/media/previous-page-icon.1117fd2b.svg";